// This import loads the firebase namespace along with all its type information.
import Issue from './issue-model'

export async function load_issues(): Promise<Issue[]> {
  throw 'Not implemented'
}

export async function delete_issue(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_issue(): Promise<Issue> {
  throw 'Not implemented'
}
